// noinspection JSVoidFunctionReturnValueUsed

const productRangeEdit = ((jQuery) => {
  'use strict';

  let $form = jQuery('#product_range_edit_form');

  if ($form.length === 0) {
    return;
  }


  const datatable = () => {
    var d = new Date();
    var n = d.getTime();
    $('#selectedProductsTable').DataTable({
      dom: 'Bfrtip',
      columnDefs: [{ width: 700, targets: 0 }],
      buttons:  [{
        extend: 'excel',
        filename: 'export-produit-' + n
      }],
      language: {
        "info": "Affichage _START_ à _END_ sur _TOTAL_ éléments",
        "infoEmpty": "Affichage 0 à 0 sur 0 éléments",
        "loadingRecords": "Chargement...",
        "lengthMenu": "Afficher _MENU_ éléments",
        "search": "Rechercher:",
        "zeroRecords": "Aucune données trouvées",
        "paginate": {
          "first": "Premier",
          "last": "Dernier",
          "next": "Suivant",
          "previous": "Précédent"
        },
      }
    });
  };

  const dualistbox = () => {
    $('select[name="duallistbox_products[]"]').bootstrapDualListbox({
      nonSelectedListLabel: 'Produits disponibles',
      selectedListLabel: 'Produits sélectionnés',
      preserveSelectionOnMove: 'déplacer',
      moveAllLabel: 'Tout déplacer',
      removeAllLabel: 'Tout enlever',
      infoText : false,
    }).on('change', function () {
      let selectedProducts = $(this).val();

      if (selectedProducts.length === 0) {
        $('#selectedProductsTable').DataTable().clear().draw();
      } else {
      $.ajaxSetup({
        headers: {
          'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
      });

      $.ajax({
        url: `/insights/product-ranges/products/get-products-info`,
        type: 'POST',
        data: JSON.stringify(selectedProducts),
        cache: false,
        contentType: 'application/json',
        success: function (response) {
          $('#selectedProductsTable').DataTable().clear();
          $.each(response, function (index, product) {
            if(product.section === 'sales') {
              product.section = "ventes";
            }
            $('#selectedProductsTable').DataTable().row.add([ product.ean, product.ref_id_produit, product.enseigne, product.section]).draw();
          });
        }
      });
    }
    });
  };

  const categoriesList = () => {
    let brand_id = window.brand;
    let category_id = window.category;

    $.ajax({
      url: `/insights/product-ranges/categories/getByBrand/${brand_id}`,
      type: 'GET',
      success: function (response) {
        $('#product_range_categories').empty();
        $.each(response, function (index, category) {
          if(category.id === category_id) {
            $('#product_range_categories').append('<option selected="selected" value="' + category.id + '">' + category.name + '</option>');
          } else {
            $('#product_range_categories').append('<option value="' + category.id + '">' + category.name + '</option>');
          }
        });
      }
    });
  };

  const productsDualist = () => {
      let brand_id = window.brand;
      let selected_products = window.products;

      $.ajax({
        url: `/insights/product-ranges/ranges/getProductByBrand/${brand_id}`,
        type: 'GET',
        success: function (response) {
          $('#duallistbox_products').empty();
          $.each(response, function (index, product) {
            if( selected_products.includes(product.id)) {
              $('#duallistbox_products').append('<option selected="selected" value="' + product.id + '">' + product.name + '</option>');
            } else {
              $('#duallistbox_products').append('<option value="' + product.id + '">' + product.name + '</option>');
            }
          });
          $('#duallistbox_products').bootstrapDualListbox('refresh');
        }
      });

    $.ajaxSetup({
      headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
      }
    });

    $.ajax({
      url: `/insights/product-ranges/products/get-products-info`,
      type: 'POST',
      data: JSON.stringify(selected_products),
      cache: false,
      contentType: 'application/json',
      success: function (response) {
        $('#selectedProductsTable').DataTable().clear();
        $.each(response, function (index, product) {
          if(product.section === 'sales') {
            product.section = "ventes";
          }
          $('#selectedProductsTable').DataTable().row.add([product.ean, product.ref_id_produit, product.enseigne, product.section]).draw();
        });
      }
    });

  };

  jQuery(() => {
    datatable();
    dualistbox();
    categoriesList();
    productsDualist();
  });

})(jQuery);
